import { isDefined } from "@clipboard-health/util-ts";
import { useToast } from "@src/appV2/lib";
import { generatePath, useHistory } from "react-router-dom";

import { LoadingButton } from "../../components/LoadingButton";
import { useGetMiscRequirement } from "../api/wrappers/useGetMiscRequirement";
import { DOCUMENT_DETAILS_FULL_PATH } from "../paths";

export function UploadMiscDocumentButton() {
  // we use this kind of as a mutation to fetch on demand only when the button is clicked
  const { refetch, isFetching } = useGetMiscRequirement({ enabled: false });

  const { showErrorToast } = useToast();

  const history = useHistory();

  return (
    <LoadingButton
      variant="outlined"
      isLoading={isFetching}
      onClick={async () => {
        const { data: miscRequirement, isError } = await refetch();

        if (isError || !isDefined(miscRequirement)) {
          showErrorToast(
            "Something went wrong initiating the miscellaneous document upload. Please try again in a moment"
          );
          return;
        }

        history.push(
          generatePath(DOCUMENT_DETAILS_FULL_PATH, {
            requirementId: miscRequirement?.id,
          })
        );
      }}
    >
      Can&apos;t find the right document?
    </LoadingButton>
  );
}
